/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { FixedPriceQuoteResource } from './';
import {
    FixedPriceQuoteResourceFromJSON,
    FixedPriceQuoteResourceFromJSONTyped,
    FixedPriceQuoteResourceToJSON,
} from './';
import type { Freelancer } from './';
import {
    FreelancerFromJSON,
    FreelancerFromJSONTyped,
    FreelancerToJSON,
} from './';
import type { InvoicingModeType } from './';
import {
    InvoicingModeTypeFromJSON,
    InvoicingModeTypeFromJSONTyped,
    InvoicingModeTypeToJSON,
} from './';
import type { QuoteClientTermsResource } from './';
import {
    QuoteClientTermsResourceFromJSON,
    QuoteClientTermsResourceFromJSONTyped,
    QuoteClientTermsResourceToJSON,
} from './';
import type { QuoteProjectTermsResource } from './';
import {
    QuoteProjectTermsResourceFromJSON,
    QuoteProjectTermsResourceFromJSONTyped,
    QuoteProjectTermsResourceToJSON,
} from './';
import type { QuoteStatus } from './';
import {
    QuoteStatusFromJSON,
    QuoteStatusFromJSONTyped,
    QuoteStatusToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';
import type { TimeAndMaterialsQuoteResource } from './';
import {
    TimeAndMaterialsQuoteResourceFromJSON,
    TimeAndMaterialsQuoteResourceFromJSONTyped,
    TimeAndMaterialsQuoteResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteResource
 */
export interface QuoteResource {
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    id: string;
    /**
     * 
     * @type {Client}
     * @memberof QuoteResource
     */
    client: Client;
    /**
     * 
     * @type {Freelancer}
     * @memberof QuoteResource
     */
    freelancer: Freelancer;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    conversationId?: string;
    /**
     * 
     * @type {QuoteStatus}
     * @memberof QuoteResource
     */
    status: QuoteStatus;
    /**
     * 
     * @type {Currency}
     * @memberof QuoteResource
     */
    currencyCode: Currency;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    title: string;
    /**
     * 
     * @type {QuoteProjectTermsResource}
     * @memberof QuoteResource
     */
    projectTerms?: QuoteProjectTermsResource;
    /**
     * 
     * @type {QuoteClientTermsResource}
     * @memberof QuoteResource
     */
    clientTerms?: QuoteClientTermsResource;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    freelancerTermsAndConditions?: string;
    /**
     * 
     * @type {QuoteType}
     * @memberof QuoteResource
     */
    type: QuoteType;
    /**
     * 
     * @type {Date}
     * @memberof QuoteResource
     */
    submissionDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof QuoteResource
     */
    cancellationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof QuoteResource
     */
    expirationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    pdfUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    freelancerExternalReference?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteResource
     */
    isAmendable: boolean;
    /**
     * True while the freelancer verification is postponed and still running (PROJ-2974). Combined with the status it tells the freelancer whether the client is blocked from accepting (status ACCEPTANCE_BLOCKED) or can accept right away thanks to a legal bypass, with the payouts held until the verification completes.
     * @type {boolean}
     * @memberof QuoteResource
     */
    isFreelancerVerificationPending: boolean;
    /**
     * 
     * @type {InvoicingModeType}
     * @memberof QuoteResource
     */
    invoicingModeType?: InvoicingModeType;
}

/**
 * Check if a given object implements the QuoteResource interface.
 */
export function instanceOfQuoteResource(value: object): value is QuoteResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('isAmendable' in value) || value['isAmendable'] === undefined) return false;
    if (!('isFreelancerVerificationPending' in value) || value['isFreelancerVerificationPending'] === undefined) return false;
    return true;
}

export function QuoteResourceFromJSON(json: any): QuoteResource {
    return QuoteResourceFromJSONTyped(json, false);
}

export function QuoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'FIXED_PRICE') {
            return FixedPriceQuoteResourceFromJSONTyped(json, true);
        }
        if (json['type'] === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsQuoteResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'id': json['id'],
        'client': ClientFromJSON(json['client']),
        'freelancer': FreelancerFromJSON(json['freelancer']),
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'status': QuoteStatusFromJSON(json['status']),
        'currencyCode': CurrencyFromJSON(json['currencyCode']),
        'title': json['title'],
        'projectTerms': json['projectTerms'] == null ? undefined : QuoteProjectTermsResourceFromJSON(json['projectTerms']),
        'clientTerms': json['clientTerms'] == null ? undefined : QuoteClientTermsResourceFromJSON(json['clientTerms']),
        'freelancerTermsAndConditions': json['freelancerTermsAndConditions'] == null ? undefined : json['freelancerTermsAndConditions'],
        'type': QuoteTypeFromJSON(json['type']),
        'submissionDate': json['submissionDate'] == null ? undefined : (new Date(json['submissionDate'])),
        'cancellationDate': json['cancellationDate'] == null ? undefined : (new Date(json['cancellationDate'])),
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'pdfUrl': json['pdfUrl'] == null ? undefined : json['pdfUrl'],
        'freelancerExternalReference': json['freelancerExternalReference'] == null ? undefined : json['freelancerExternalReference'],
        'isAmendable': json['isAmendable'],
        'isFreelancerVerificationPending': json['isFreelancerVerificationPending'],
        'invoicingModeType': json['invoicingModeType'] == null ? undefined : InvoicingModeTypeFromJSON(json['invoicingModeType']),
    };
}

export function QuoteResourceToJSON(value?: QuoteResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'FIXED_PRICE') {
            return FixedPriceQuoteResourceToJSON(value as FixedPriceQuoteResource);
        }
        if (value.type === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsQuoteResourceToJSON(value as TimeAndMaterialsQuoteResource);
        }
    }
    return {
        
        'id': value['id'],
        'client': ClientToJSON(value['client']),
        'freelancer': FreelancerToJSON(value['freelancer']),
        'conversationId': value['conversationId'],
        'status': QuoteStatusToJSON(value['status']),
        'currencyCode': CurrencyToJSON(value['currencyCode']),
        'title': value['title'],
        'projectTerms': QuoteProjectTermsResourceToJSON(value['projectTerms']),
        'clientTerms': QuoteClientTermsResourceToJSON(value['clientTerms']),
        'freelancerTermsAndConditions': value['freelancerTermsAndConditions'],
        'type': QuoteTypeToJSON(value['type']),
        'submissionDate': value['submissionDate'] == null ? undefined : ((value['submissionDate']).toISOString()),
        'cancellationDate': value['cancellationDate'] == null ? undefined : ((value['cancellationDate']).toISOString()),
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate']).toISOString()),
        'pdfUrl': value['pdfUrl'],
        'freelancerExternalReference': value['freelancerExternalReference'],
        'isAmendable': value['isAmendable'],
        'isFreelancerVerificationPending': value['isFreelancerVerificationPending'],
        'invoicingModeType': InvoicingModeTypeToJSON(value['invoicingModeType']),
    };
}

